// extracted by mini-css-extract-plugin
module.exports = {"pageName":"Receipe_pageName__3VuQx"};